import { render, staticRenderFns } from "./centerPersonal.vue?vue&type=template&id=0e26e020&scoped=true"
import script from "./centerPersonal.vue?vue&type=script&lang=js"
export * from "./centerPersonal.vue?vue&type=script&lang=js"
import style0 from "./centerPersonal.vue?vue&type=style&index=0&id=0e26e020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e26e020",
  null
  
)

export default component.exports